import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const CustomModal = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "sm",
  fullWidth = true,
  PaperProps = {},
  hideCloseIcon = false,
  titleSx = {},
  contentSx = {},
  actionsSx = {},
  dividers = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        ...PaperProps,
        style: { borderRadius: "12px", ...PaperProps?.style },
        className: PaperProps?.className,
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            fontWeight: 600,
            color: "#1e293b",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            ...titleSx,
          }}
        >
          {title}
          {!hideCloseIcon && onClose && (
            <IconButton
              onClick={onClose}
              size="small"
              sx={{ ml: 2, color: "#64748b" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent dividers={dividers} sx={{ ...contentSx }}>
        {children}
      </DialogContent>

      {actions && (
        <DialogActions sx={{ px: 3, pb: 3, gap: 1, ...actionsSx }}>
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CustomModal;
